module.exports = "/assets/pattern-fdw-tile.png?cVa5GmT";